<template>
  <el-collapse class='query-condition' v-model='seq'>
    <el-collapse-item name="1">
      <template slot="title">
        <el-button type='primary'>
          查询条件
        </el-button>
        <div style="width: 100%; text-align: center;" v-if="title">
          <h2>{{ title }}</h2>
        </div>
      </template>
      <el-form label-width="100px"
               ref="form">
        <slot></slot>
      </el-form>
      <el-button-group class='fr btns'>
        <el-button @click='close' icon="el-icon-close">关闭</el-button>
        <el-button @click='reset' icon="fa fa-eraser"> 清空</el-button>
        <el-button type="primary" @click='query'
                   icon="el-icon-search" :loading="loading">查询</el-button>
      </el-button-group>
      <div class='cl'></div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
  export default {
    props: ['title', 'loading'],
    data() {
      return {
        seq: ''
      }
    },
    methods: {
      close() {
        this.seq = '';
      },
      reset() {
        this.$emit('reset');
      },
      query() {
        this.close();
        this.$emit('query');
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>
  .query-condition {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    width: 99%;
  }
  .btns {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cx/cxQueryCondition.vue